import React from "react";
import { tokenizeQuery, resolveActiveOrderSearchQuery } from "../utils/dataManagerOrderSearch.js";

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function buildHighlightParts(text, tokens) {
  const validTokens = tokens.filter((token) => token.length >= 2);
  if (!text || validTokens.length === 0) {
    return [{ highlighted: false, value: text }];
  }

  const pattern = validTokens
    .sort((left, right) => right.length - left.length)
    .map((token) => escapeRegExp(token))
    .join("|");
  const regex = new RegExp(`(${pattern})`, "gi");
  const parts = [];
  let lastIndex = 0;

  for (const match of text.matchAll(regex)) {
    const start = match.index ?? 0;
    if (start > lastIndex) {
      parts.push({ highlighted: false, value: text.slice(lastIndex, start) });
    }
    parts.push({ highlighted: true, value: match[0] });
    lastIndex = start + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push({ highlighted: false, value: text.slice(lastIndex) });
  }

  return parts.length > 0 ? parts : [{ highlighted: false, value: text }];
}

export default function DataManagerOrdersSearchHighlight({
  children = "",
  className = "",
  searchQuery = "",
  title = undefined,
}) {
  const text = children === null || children === undefined ? "" : String(children);
  const tokens = tokenizeQuery(resolveActiveOrderSearchQuery(searchQuery));
  const parts = buildHighlightParts(text, tokens);

  if (!text) {
    return <span className={className} title={title}>—</span>;
  }

  return (
    <span className={className} title={title}>
      {parts.map((part, index) => (
        part.highlighted ? (
          <mark key={`${part.value}-${index}`} className="rounded-sm bg-amber-100/80 px-0.5 text-inherit">{part.value}</mark>
        ) : (
          <React.Fragment key={`${part.value}-${index}`}>{part.value}</React.Fragment>
        )
      ))}
    </span>
  );
}
